export const environments = {
    PRODUCTION: false,
    USER_ENV_NOT_PDN: 'facturacionelectronicasufi',
    PASS_ENV_NOT_PDN: 'Uw3Fbu@e+fz4O}ur',
    BACK_URL_BASE: 'https://sufi-ext-dev.apps.ambientesbc.com/facturacion-electronica-sufi/back/',
    FACTURA_FINDALL_URL_SERVICE: 'api/factura',
    FACTURA_EXPORT_URL_SERVICE: 'api/factura/export',
    FACTURA_GET_URL_SERVICE: 'api/factura',
    AZURE_CONFIG:{
      REDIRECT_URI: 'https://facturacion-sufi-mig-dev.apps.ambientesbc.com/home',
      CLIENT_ID:'06497be6-1772-436f-aab3-c0dda6b63332',
      TENAN_ID:'428f4e2e-13bf-4884-b364-02ef9af41a1d',
      AUTHORITY:'https://login.microsoftonline.com/428f4e2e-13bf-4884-b364-02ef9af41a1d',
      TOKEN_SCOPE: 'api://06497be6-1772-436f-aab3-c0dda6b63332/WebApiB.ExampleScope',
    }
  };